__turbopack_context__.v({
  "className": "_JUnBa_className",
  "variable": "_JUnBa_variable",
});
